export const BLUE = '#026CAC';
export const BLUE2 = '#2185D0';
export const BLUE3 = '#034566';
export const BLUE4 = '#51A2CB'
export const GREY = '#9B9B9B';
export const GREY2 = '#F3F3F5';
export const GREY3 = '#4A4A4A';
 
